<template>
  <div class="smartvoiceItem">
    <div class="flexBox mb15">
      <div class="flexInner">
        <input type="text" class="input sizeL" v-model="item.groupName">
        <button type="button" class="btn btnPrimary" @click="updateGroup">{{locale.modify}}</button>
      </div>
      <div class="flexInner right">
        <button type="button" class="btn btnRed" @click="delGroup">{{locale.delete_group}}</button>
      </div>
    </div>
    <button type="button" class="btn btnWhite" @click="add">{{locale.add_voice}}</button>
    <!-- audio player -->
    <div ref="audioPlayer"></div>
    <!-- audio player -->
    <div v-if="voiceList && voiceList.length" class="itemGroup">
      <p v-if="!item.defaultVoice && voiceList.length > 1" class="colorRed message">ⓘ {{locale.message_representation_voice}}</p>
      <div v-for="(voice, index) in voiceList"
        :key="index"
        :data-lang="voice.voice.languageCode"
        class="item"
        :class="{
          active: isActive(voice.voice.languageCode),
          isNew: itemInfo(voice).isNew,
          invalid: !itemInfo(voice).isValid,
          isPlaing: isPlaing(voice)}">
        <div v-if="voiceList.length > 1 && voice.createat" class="checkbox onoff">
          <input type="checkbox"
            :id="`default_lang_${voice.voice.languageCode}`"
            :checked="defualtLang(voice)"
            :disabled="defualtLang(voice)"
            @change="updateDefaultVoice(voice)">
          <label :for="`default_lang_${voice.voice.languageCode}`">{{locale.representation_voice}}</label>
        </div>
        <!-- 새 음성 -->
        <div v-if="itemInfo(voice).isNew">
          <!-- 언어 선택 -->
          <select v-model="voice.voice.languageCode" :disabled="isPlaing(voice)" class="input select mb5">
            <option value="">{{locale.message_select_language}}</option>
            <option
              v-for="v in voiceInfo"
              :key="v.code"
              :value="v.code"
              :disabled="existCode.includes(v.code)">
              {{v.country}} [{{v.code}}]
            </option>
          </select>
          <!-- //언어 선택 -->
          <textarea class="input textarea" :maxlength="maxLength" :disabled="isPlaing(voice)" :placeholder="locale.content_placeholder" v-model="voice.ttsText"></textarea>
          <p class="colorGrey textLength">{{voice.ttsText ? comma(voice.ttsText.length) : 0}} / {{comma(maxLength)}}</p>
          <!-- 음성 -->
          <select v-if="voice.voice.languageCode" v-model="voice.voice.name" :disabled="isPlaing(voice)" @change="setVoice(index, voice.voice.languageCode, voice.voice.name)" class="input select mt5">
            <option value="">{{locale.message_select_voice_type}}</option>
            <option
              v-for="v in getVoices(voice.voice.languageCode)"
              :key="v.name"
              :value="v.name">
              <span v-html="genderToEmoji(v.ssmlGender)"></span>
              {{voiceName(v.name)}} ({{v.ssmlGender}})
            </option>
          </select>
          <!-- //음성 -->
          <div v-if="voice.voice.name">
            <!-- 속도 -->
            <div class="mt10">
              <p class="voiceDetail">
                {{locale.voice_speed}} ({{parseFloat(voice.speed).toFixed(1)}})
                <button type="button" class="btn btnWhite sizeS toCapitalize" @click="defaultInputVoice(voice, 'speed')">{{locale.set_default}}</button>
              </p>
              <div class="rangeSlider">
                <input type="range" min="0.5" max="1.7" step="0.1" :disabled="isPlaing(voice)" v-model="voice.speed">
              </div>
            </div>
            <!-- //속도 -->
            <!-- 높이 -->
            <div class="mt5">
              <p class="voiceDetail">
                {{locale.voice_pitch}} ({{parseFloat(voice.pitch).toFixed(1)}})
                <button type="button" class="btn btnWhite sizeS toCapitalize" @click="defaultInputVoice(voice, 'pitch')">{{locale.set_default}}</button>
              </p>
              <div class="rangeSlider">
                <input type="range" min="-3" max="3" step="0.5" :disabled="isPlaing(voice)" v-model="voice.pitch">
              </div>
            </div>
            <!-- //높이 -->
          </div>
          <div class="btns mt10">
            <button type="button" class="btn btnWhite sizeS toCapitalize" :disabled="isPlaing(voice)" @click="cancel(voice.voice.languageCode)">{{locale.cancel}}</button>
            <!-- 중지 -->
            <button
              v-if="isPlaing(voice)"
              type="button"
              class="btn btnWhite sizeS right"
              @click="stopPreview">
              ■ {{locale.play_stop}}
            </button>
            <!-- //중지 -->
            <!-- 미리듣기 -->
            <button
              v-else
              type="button"
              class="btn btnWhite sizeS right"
              :disabled="!itemInfo(voice).isValid"
              @click="preview(voice)">
              ▶ {{locale.play_preview}}
            </button>
            <!-- //미리듣기 -->
            <button type="button" class="btn btnPrimary sizeS ml5 toCapitalize" :class="{btnGrey: isPlaing(voice)}" :disabled="!itemInfo(voice).isValid || isPlaing(voice)" @click="create(voice)">{{locale.save}}</button>
          </div>
        </div>
        <!-- //새 음성 -->
        <!-- 기존 음성 -->
        <div v-else>
          <button type="button" class="btnSetting" :disabled="isPlaing(voice)" @click="active = voice.voice.languageCode"><img src="@/assets/img/ico_setting.svg" alt=""></button>
          <!-- 언어 코드 -->
          <span class="lang">{{langLabel(voice.voice.languageCode)}}</span>
          <!-- 언어 코드 -->
          <textarea class="input textarea" :maxlength="maxLength" :disabled="isPlaing(voice)" :placeholder="locale.content_placeholder" :readonly="!isActive(voice.voice.languageCode)" v-model="voice.ttsText"></textarea>
          <div v-if="isActive(voice.voice.languageCode)">
            <p class="colorGrey textLength">{{voice.ttsText ? comma(voice.ttsText.length) : 0}} / {{comma(maxLength)}}</p>
            <div class="btns mt10">
              <select class="input select" :disabled="isPlaing(voice)" v-model="voice.voice.name">
                <option
                  v-for="v in activeVoice"
                  :key="v.name"
                  :value="v.name">
                  <span v-html="genderToEmoji(v.ssmlGender)"></span>
                  {{voiceName(v.name)}} ({{v.ssmlGender}})
                </option>
              </select>
            </div>
            <!-- 속도 -->
            <div class="mt10">
              <p class="voiceDetail">
                {{locale.voice_speed}} ({{parseFloat(voice.speed).toFixed(1)}})
                <button type="button" class="btn btnWhite sizeS toCapitalize" @click="defaultInputVoice(voice, 'speed')">{{locale.set_default}}</button>
              </p>
              <div class="rangeSlider">
                <input type="range" min="0.5" max="1.7" step="0.1" :disabled="isPlaing(voice)" v-model="voice.speed">
              </div>
            </div>
            <!-- //속도 -->
            <!-- 높이 -->
            <div class="mt5">
              <p class="voiceDetail">
                {{locale.voice_pitch}} ({{parseFloat(voice.pitch).toFixed(1)}})
                <button type="button" class="btn btnWhite sizeS toCapitalize" @click="defaultInputVoice(voice, 'pitch')">{{locale.set_default}}</button>
              </p>
              <div class="rangeSlider">
                <input type="range" min="-3" max="3" step="0.5" :disabled="isPlaing(voice)" v-model="voice.pitch">
              </div>
            </div>
            <!-- //높이 -->
            <div class="btns mt10">
              <button type="button" class="btn btnWhite sizeS toCapitalize" :disabled="defualtLang(voice) || isPlaing(voice)" @click="del(voice)">{{locale.delete}}</button>
              <!-- 중지 -->
              <button
                v-if="isPlaing(voice)"
                type="button"
                class="btn btnWhite sizeS right"
                @click="stopPreview">
                ■ {{locale.play_stop}}
              </button>
              <!-- //중지 -->
              <!-- 미리듣기 -->
              <button
                v-else
                type="button"
                class="btn btnWhite sizeS right"
                :disabled="!itemInfo(voice).isValid"
                @click="preview(voice)">
                ▶ {{locale.play_preview}}
              </button>
              <!-- //미리듣기 -->
              <button type="button" class="btn sizeS ml5 toCapitalize" :class="{btnGrey: isPlaing(voice)}" :disabled="!itemInfo(voice).isValid || isPlaing(voice)" @click="save(voice)">{{locale.save}}</button>
            </div>
          </div>
        </div>
        <!-- //기존 음성 -->
      </div>
    </div>
    <p v-else class="nodata mt30">{{locale.smartvoice_voice_nodata}}</p>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'SmartVoiceItem',
  props: [
    'locale',
    'item',
    'voiceInfo'
  ],
  computed: {
    voiceList () {
      return this.item.detail
    },
    activeVoice () {
      return this.getVoices(this.active)
    },
    existCode () {
      return this.voiceList.map(x => x.voice.languageCode)
    }
  },
  mounted () {
  },
  data () {
    return {
      active: null,
      audio: null,
      audioLang: null,
      maxLength: 2000,
      defaultSpeed: 1.0,
      defaultPitch: 0.0
    }
  },
  methods: {
    comma (num) {
      return regExp.comma(num)
    },
    langLabel (lang) {
      const l = this.voiceInfo && this.voiceInfo.find(x => x.code === lang)
      return l ? `${l.country} [${l.code}]` : null
    },
    isActive (lang) {
      return this.active === lang
    },
    genderToEmoji (gender) {
      const g = gender.toLowerCase()
      return g === 'female' ? '&#128105;' : '&#129489;'
    },
    voiceName (name) {
      const langCode = `${this.active}-`
      return name.replace(langCode, '')
    },
    itemInfo (item) {
      const itemVoice = item.voice.languageCode && item.voice.name && item.voice.ssmlGender
      const isValid = regExp.replaceAllEmpty(item.ttsText).length && itemVoice
      return {
        isNew: !item.createat,
        isValid: isValid
      }
    },
    getVoices (code) {
      const hasVoice = this.voiceInfo.find(x => x.code === code) && this.voiceInfo.find(x => x.code === code).voices
      return hasVoice ? hasVoice.map(x => x).sort((a, b) => {
        return a.name < b.name ? -1 : 1
      }) : []
    },
    disabledDefaultVoice (voice) {
      return !voice.createat || voice.voice.languageCode === ''
    },
    setVoice (index, code, voiceName) {
      const voice = this.voiceInfo.find(x => x.code === code)
      const voiceInfo = voice && voice.voices.find(x => x.name === voiceName)
      this.item.detail[index].voice.ssmlGender = voiceInfo && voiceInfo.ssmlGender
    },
    defaultInputVoice (voice, target) {
      const targetName = target.replace(/\b[a-z]/, x => x.toUpperCase())
      const data = `default${targetName}`
      voice[target] = this[data]
    },
    // audio el 생성
    playAudio (src) {
      const audioPlayer = this.$refs.audioPlayer
      const audio = document.createElement('audio')
      audio.src = src
      audio.autoplay = 'autoplay'
      audioPlayer.appendChild(audio)
      audioPlayer.querySelector('audio').addEventListener('ended', this.stopPreview)
    },
    selectionText () {
      const selection = window.getSelection()
      if (selection && selection.type === 'Range') {
        const closest = selection.focusNode.closest('[data-lang]')
        const selectionLang = closest && closest.getAttribute('data-lang')
        const returnSelection = selectionLang === this.audioLang
        return returnSelection ? selection.toString() : ''
      } else {
        return ''
      }
    },
    // audio el play
    async preview (voice) {
      const data = {
        voice: voice.voice,
        text: voice.ttsText,
        speed: voice.speed,
        pitch: voice.pitch
      }
      const selection = window.getSelection()
      this.audioLang = voice.voice.languageCode
      if (this.selectionText() && this.selectionText().length) {
        data.text = this.selectionText()
      }
      this.stopPreview()
      this.$store.commit('onLoading', true)
      this.$store.dispatch('smartvoice/previewVoice', data).then((res) => {
        if (res && res.contents) {
          const src = `data:audio/mp3;base64,${res.contents}`
          this.audio = src
          this.audioLang = voice.voice.languageCode
          this.playAudio(src)
          selection.removeAllRanges()
        }
        this.$store.commit('onLoading', false)
      })
    },
    // audio el 제거, 초기화
    stopPreview () {
      const audioPlayer = this.$refs.audioPlayer
      if (audioPlayer) {
        audioPlayer.innerHTML = ''
      }
      this.audio = null
      this.audioLang = null
    },
    isPlaing (voice) {
      return this.audio && voice.voice.languageCode === this.audioLang
    },
    // 최하단으로 스크롤 이동
    scrollBottom (el) {
      let scrollChecker = setInterval(() => {
        if (document.getElementById(el)) {
          const box = document.getElementById(el)
          box.scrollTop = box.scrollHeight
        }
      }, 100)
      setTimeout(() => {
        clearInterval(scrollChecker)
      }, 500)
    },
    defualtLang (voice) {
      return this.item.defaultVoice === voice.voice.languageCode
    },
    updateDefaultVoice (voice) {
      if (window.confirm(`${voice.voice.languageCode}:: ${this.locale.confirm_set_representative_voice}`)) {
        this.setDefaultVoice(voice)
      }
    },
    setDefaultVoice (voice) {
      const groupId = this.item.id
      const groupName = this.item.groupName
      const data = {
        groupId: groupId,
        groupName: groupName,
        defaultVoice: voice.voice.languageCode
      }
      this.$emit('updateGroup', data)
    },
    add () {
      const defaultVoice = {
        ttsText: '',
        voice: {
          languageCode: '',
          name: '',
          ssmlGender: ''
        },
        speed: 1.0,
        pitch: 0.0
      }
      this.item.detail = [ ...this.item.detail, defaultVoice ]
      this.scrollBottom('smartVoiceItemBox')
    },
    cancel (lang) {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.item.detail = this.item.detail.filter(x => x.voice && x.voice.languageCode !== lang)
      }
    },
    create (voice) {
      if (window.confirm(this.locale.confirm_save)) {
        const data = {
          groupId: this.item.id,
          voice: voice.voice,
          text: voice.ttsText,
          speed: voice.speed,
          pitch: voice.pitch
        }
        this.$store.commit('onLoading', true)
        if (this.item.detail.length === 1) {
          this.setDefaultVoice(voice)
        }
        this.$store.dispatch('smartvoice/createVoice', data).then((res) => {
          if (res && this.item.detail.length > 1) {
            alert(this.locale.complete_save)
            this.$emit('setItem', this.item.id)
          }
          this.$store.commit('onLoading', false)
        })
      }
    },
    del (voice) {
      if (window.confirm(this.locale.confirm_delete)) {
        const groupId = this.item.id
        const languageCode = voice.voice.languageCode
        const data = {
          groupId: groupId,
          languageCode: languageCode
        }
        this.$store.commit('onLoading', true)
        this.$store.dispatch('smartvoice/deleteVoice', data).then((res) => {
          if (res) {
            alert(this.locale.complete_delete)
            setTimeout(() => {
              this.$emit('setItem', this.item.id)
            }, 500)
          }
          this.$store.commit('onLoading', false)
        })
      }
    },
    save (voice) {
      if (window.confirm(this.locale.confirm_save)) {
        const data = {
          groupId: this.item.id,
          voice: voice.voice,
          text: voice.ttsText,
          speed: voice.speed || 1.0,
          pitch: voice.pitch || 0.0
        }
        this.$store.commit('onLoading', true)
        this.$store.dispatch('smartvoice/updateVoice', data).then((res) => {
          if (res) {
            alert(this.locale.complete_save)
            setTimeout(() => {
              this.$emit('setItem', this.item.id)
            }, 500)
          }
          this.$store.commit('onLoading', false)
        })
      }
    },
    delGroup (voice) {
      if (window.confirm(`${this.locale.confirm_delete_group}\n${this.locale.confirm_delete}`)) {
        const groupId = this.item.id
        this.$emit('deleteGroup', groupId)
      }
    },
    updateGroup () {
      if (window.confirm(this.locale.confirm_update_group)) {
        const groupId = this.item.id
        const groupName = this.item.groupName
        const data = {
          groupId: groupId,
          groupName: groupName
        }
        this.$emit('updateGroup', data)
      }
    }
  }
}
</script>
